<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kfccAq/tc-custom/9781936535330.jpg?1718183000721" alt="This image is the cover for the book Lieutenant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lieutenant
      </h1>
      <p class="bookDescription body article font2">
        <p>The year is 2804 AD. Humanity has colonized the universe. But the authority of the Confederation of Human Worlds is spread thin. Where the Army of planet Earth cannot reach, mercenaries must keep the peace--and the Dirigent Mercenary Corps are the best of the best.<br/><br/> Kicked out of the prestigious North American Military Academy, Lon Nolan had only a few choices left to him. He chose the hardest one: serving with the Dirigent Mercenary Corps, an elite fighting squad where respect is earned not in the classroom but on the battlefield.<br/><br/>Nolan proved himself on the battlefield on Norbank. But now he’s commanding men of his own, and the stakes are higher. He’s going to learn sooner or later that leadership always comes with a cost...<br/><br/>The <i>Dirigent Mercenary Corps</i> books are classics of military science fiction. Rick Shelley was himself a veteran of the U.S. Army, and his experience and knowledge shine through on every page.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Shelley
      </h2>
      
      <p class="authorDescription body article">Rick Shelley (January 1, 1947 - January 27, 2001) was a military science fiction author. In addition to a plethora of short fiction, he also wrote the Dirigent Mercenary Corps, Spec Ops Squad, Federation War, 13 Spaceborn, Seven Towers, and Varayan Memoir series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Jabberwocky Literary Agency
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0184a0ee